import * as React from 'react';
import BibleVerse from 'src/bible/BibleVerse';
import SourceTestament from 'src/new/sources/SourceTestament';
import SourceTextCache from 'src/new/sources/SourceTextCache';
import VersionStore from 'src/new/versions/VersionStore';
import SearchQuery from 'src/search2/SearchQuery';
import Immutable from 'src/util/Immutable';
import SelectedVersions from 'src/versions/SelectedVersions';
import ChapterList from './ChapterList';
import VerseList from './VerseList';

interface Props {
    initialFocusedVerse: Immutable<BibleVerse>;
    currentFocusedVerse: Immutable<BibleVerse>;
    versions: VersionStore;
    selectedVersions: SelectedVersions;
    sourceTextCache: SourceTextCache;
    highlightQuery: SearchQuery;
    onFocusedVerseChange: (verse: BibleVerse) => void;
    onWordClick: (verseIndex: number, sourceIndex: number, wordIndex: number, partIndex: number, text: string) => void;
}

interface State {
    focusedVerse: Immutable<BibleVerse>;
}

export default class BookVerseList extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            focusedVerse: props.initialFocusedVerse
        };
    }

    public render(): React.ReactNode {
        const book = this.props.initialFocusedVerse.get().getBook();

        if (this.useChapterView(this.props)) {
            return <ChapterList
                book={book}
                initialFocusedVerse={this.state.focusedVerse}
                chapters={book.getChapters()}
                versions={this.props.versions}
                selectedVersionIndex={this.props.selectedVersions.getSelected()[0]}
                sourceTextCache={this.props.sourceTextCache}
                highlightQuery={this.props.highlightQuery}
                onFocusedVerseChange={this.props.onFocusedVerseChange}
                onWordClick={this.props.onWordClick} />;
        } else {
            const bookVerses = book.getChapters().reduce<BibleVerse[]>(
                (previousValue, currentValue) => previousValue.concat(currentValue.getVerses()), []);

            return <VerseList
                book={book}
                initialFocusedVerse={this.state.focusedVerse}
                verses={bookVerses}
                versions={this.props.versions}
                selectedVersions={this.props.selectedVersions}
                sourceTextCache={this.props.sourceTextCache}
                highlightQuery={this.props.highlightQuery}
                onFocusedVerseChange={this.props.onFocusedVerseChange}
                onWordClick={this.props.onWordClick} />;
        }
    }

    public componentDidUpdate(prevProps: Readonly<Props>): void {
        if (this.useChapterView(prevProps) !== this.useChapterView(this.props)) {
            this.setState({
                focusedVerse: this.props.currentFocusedVerse
            });
        } else if (prevProps.initialFocusedVerse !== this.props.initialFocusedVerse) {
            this.setState({
                focusedVerse: this.props.initialFocusedVerse
            });
        }
    }

    private useChapterView(props: Readonly<Props>): boolean {
        const book = props.initialFocusedVerse.get().getBook();
        const visibleVersions = props.selectedVersions.getSelectedVersions(props.versions).filter(version => {
            return version.getTestament() === SourceTestament.Both ||
                version.getTestament().toString() === book.getTestament().toString();
        });
        return visibleVersions.length === 1;
    }
}
